import useUsageLimits from "../../hooks/Useusagelimits.js";
import { useAuth } from "../../context/authContext";
import GlassCard from "../ui/GlassCard";
import ProgressBar from "../ui/ProgressBar";
import LoadingState from "../ui/LoadingState";
import { MessageCircle, HeartHandshake } from "lucide-react";

const UsageLimits = ({ name = "Usage Limits" }) => {
  const { code } = useAuth();
  const { usage, loading, error } = useUsageLimits(code);

  // "WAP" (and any code the backend returns null for) never shows this section.
  if (code === "WAP") return null;
  if (!loading && (error || !usage)) return null;

  return (
    <GlassCard accent="violet" className="flex flex-col gap-5 text-slate-900 dark:text-white">
      <h1 className="font-['Space_Grotesk',_sans-serif] text-[22px] font-semibold">{name}</h1>

      {loading && <LoadingState rows={2} />}

      {!loading && usage && (
        <div className="flex flex-col gap-5">
          <UsageRow
            icon={MessageCircle}
            label="Messages"
            count={usage.messageCount}
            limit={usage.messageLimit}
            reached={usage.messageLimitReached}
            free={usage.isChatBotFree}
          />
           {code == "AIIMS" ? (
              ""
            ) : (<UsageRow
            icon={HeartHandshake}
            label="Therapy Sessions"
            count={usage.therapyCount}
            limit={usage.therapyLimit}
            reached={usage.therapyLimitReached}
            free={usage.isTherapyFree}
          />)}
        </div>
      )}
    </GlassCard>
  );
};

const UsageRow = ({ icon: Icon, label, count, limit, reached, free }) => {
  const percentage = limit
    ? Math.min(Number(((count / limit) * 100).toFixed(2)), 100)
    : 0;
  const color = reached ? "#FF5C7A" : "#8b7cf6";

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm font-medium text-slate-600 dark:text-white/70">
          <Icon size={15} strokeWidth={2.5} />
          {label}
        </div>

        <div className="flex items-center gap-2">
          <span
            className={`text-sm font-semibold ${
              reached ? "text-[#FF5C7A]" : "text-slate-900 dark:text-white"
            }`}
          >
            {count}/{limit}
          </span>

          {reached && (
            <span className="rounded-full bg-[#FF5C7A]/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-[#FF5C7A]">
              Limit reached
            </span>
          )}

          {free && !reached && (
            <span className="rounded-full bg-[#34d9b8]/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-[#34d9b8]">
              Free
            </span>
          )}
        </div>
      </div>

      <ProgressBar label="" value={percentage} color={color} />
    </div>
  );
};

export default UsageLimits;